(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wv-mabon-confirmation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wv-mabon-confirmation')) {
    customElements.define('wv-mabon-confirmation', class extends HTMLElement {
      connectedCallback() {
        this.hidden = new URLSearchParams(window.location.search).get('from') !== 'mabon';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
